<app-page-header title="Home" active_item="Aprovar saques" titleLink="/reports"></app-page-header>
<div class="loading-approve" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<h5>{{ 'common.approveWithdrawals' | translate }}</h5>
<div class="row">
  <div class="col-12">
    <div class="card rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">{{ 'common.withdrawals' | translate }}</div>
        <div class="card-options">
          <button
            type="button"
            class="our-button btn btn-pill btn-danger float-end"
            (click)="approve(false)"
          >
            <i class="fe fe-x"></i>{{ 'common.refuse' | translate }}
          </button>
          <button
            type="button"
            class="our-button btn btn-pill btn-primary float-end"
            (click)="approve(true)"
          >
            <i class="fe fe-check"></i>{{ 'common.approve' | translate }}
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="scrollable-layout">
          <div class="table-responsive our-table">
            <table class="table table-striped text-nowrap mb-0">
              <thead class="border-top">
                <tr>
                  <th class="align-middle text-center text-capitalize" scope="col">
                    {{ 'common.select' | translate }}
                  </th>
                  <th class="align-middle text-center text-capitalize" scope="col">{{ 'common.date' | translate }}</th>
                  <th scope="col" class="text-capitalize">{{ 'common.identifier' | translate }}</th>
                  <th scope="col" class="text-capitalize">{{ 'common.name' | translate }}</th>
                   <ng-container *ngIf="isBRL; else intlHeader">
                    <th scope="col" class="text-capitalize">{{ 'common.pix'  | translate }}</th>
                    <th scope="col" class="text-capitalize">{{ 'common.type' | translate }}</th>
                  </ng-container>
                  <ng-template #intlHeader>
                    <th scope="col" class="text-capitalize">{{ 'common.document' | translate }}</th>
                    <th scope="col" class="text-capitalize">{{ 'common.bankAccount'   | translate }}</th>
                    <th scope="col" class="text-capitalize">{{ 'common.bank' | translate }}</th>
                  </ng-template>
                  <th scope="col" class="text-capitalize">{{ 'common.status' | translate }}</th>
                  <th scope="col" class="text-capitalize">{{ 'common.value' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-bottom" *ngFor="let data of tableData">
                  <td class="align-middle text-center">
                    <label class="custom-switch">
                      <input
                        type="checkbox"
                        class="custom-switch-input"
                        [(ngModel)]="data.selected"
                      />
                      <span class="custom-switch-indicator"></span>
                    </label>
                  </td>
                  <td class="align-middle text-center">
                    <span>{{
                      data.date | date : "dd/MM/yyyy HH:mm:ss" : "GMT"
                    }}</span>
                  </td>
                  <td>
                    <span>{{ data.id }}</span>
                  </td>
                  <td>
                    <span>{{ data.name }}</span>
                  </td>
                  <ng-container *ngIf="isBRL; else intlRow">
                    <td><span class="truncate">{{ data.pixKey }}</span></td>
                    <td><span>{{ data.pixType }}</span></td>
                  </ng-container>
                  <ng-template #intlRow>
                    <td><span>{{ data.documentName }}</span></td>
                    <td><span>{{ data.accountNoBank }}</span></td>
                    <td><span>{{ data.bankName }}</span></td>
                  </ng-template>
                  <td>
                    <span>{{ data.status }}</span>
                  </td>
                  <td>
                    <span>{{
                      data.valor
                        | formatCurrency
                    }}</span>
                  </td>
                </tr>
                <tr *ngIf="tableData.length === 0">
                  <td [attr.colspan]="isBRL ? 8 : 9">{{ 'common.noData' | translate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #requestTOTPCode let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ 'common.informAuthToken' | translate }}</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click'); isLoaded = true"
    ></button>
  </div>
  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage.length > 0" class="text-danger">
        {{ errorMessage }}
      </p>
    </div>
    <div class="form-group mb-3">
      <input
        type="text"
        class="form-control"
        id="authToken"
        placeholder="Token"
        [(ngModel)]="validationCode"
        (keyup.enter)="validateTotp(); getPendingWithdraw()"
      />
      <button
        (click)="pasteTotpCode()"
        class="btn btn-primary btn-block btn-colar h-30 w-30 mx-auto mt-2 mb-1"
      >
        {{'login.totp.pasteButton' | translate}}
      </button>
    </div>
  </div>
  <div class="modal-footer text-center">
    <button
      type="submit"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="validateTotp(); getPendingWithdraw()"
      [disabled]="validatingTotp"
    >
      {{ 'common.validateButton' | translate }}
    </button>
  </div>
</ng-template>
